/* Robotow fit table: draws the rows from the fit data when the page has no server rows yet,
   and filters by answer and by text. Same row markup as snippets/rt-fit-row.liquid. */
(function () {
  "use strict";
  var tables = document.querySelectorAll("[data-rt-fit-table]");
  if (!tables.length) return;
  var Fit = window.RobotowFit;

  // "handle=url handle=url" pairs from the section (live cohort and fit pages); a fit page answers a
  // confirm or no-fit airplane first, the same rule as sections/rt-fit-table.liquid.
  function pages(attr) {
    var m = {};
    (attr || "").split(" ").forEach(function (pair) {
      var i = pair.indexOf("=");
      if (i > 0 && /^\/pages\/[a-z]+\/[a-z0-9-]+$/.test(pair.slice(i + 1))) m[pair.slice(0, i)] = pair.slice(i + 1);
    });
    return m;
  }
  function pageFor(a, maps) {
    if (a.status !== "listed" && maps.fit[a.id]) return maps.fit[a.id];
    return maps.cohort[a.id] || maps.fit[a.id] || "";
  }

  function rowHTML(a, maps, qualifyPrices) {
    var esc = Fit.esc, ad = Fit.getAdapter(a.adapter);
    var st = a.status, kind = st === "listed" ? "yes" : st === "confirm" ? "ask" : "no";
    var word = st === "listed" ? (a.unit === "6600" ? "Fits with the Pro frame, confirm with us" : a.unit === "6700" ? "Fits with the SF frame, confirm with us" : "Fits")
      : st === "confirm" ? "Confirm with us" : "Does not fit";
    var frame = a.unit === "6500" ? "Standard or Pro" : a.unit === "6600" ? "Pro" : a.unit === "6700" ? "SF" : "";
    var kit = ad ? Fit.findKit(a.unit, "5Ah", a.adapter) : null;
    var search = [a.display].concat(a.synonyms || []).join(" ").toLowerCase();
    var cond = "";
    if (a.follow_up) cond += '<span class="rt-fits-cond">' + esc(a.follow_up.q) + " We ask this first.</span>";
    if (st !== "listed" && a.fit_note) cond += '<span class="rt-fits-cond">' + esc(a.fit_note) + "</span>";
    var none = '<span class="rt-fits-none">None</span>';
    return '<tr data-status="' + st + '" data-id="' + esc(a.id) + '" data-maker="' + esc(Fit.makeOf(a)) + '" data-search="' + esc(search) + '">' +
      '<th scope="row">' + (maps && pageFor(a, maps) ? '<a href="' + esc(pageFor(a, maps)) + '">' + esc(a.display) + "</a>" : esc(a.display)) + "</th>" +
      '<td><span class="rt-state is-' + kind + '">' + Fit.glyph(kind) + "<span>" + word + "</span></span>" + cond + "</td>" +
      "<td>" + (ad ? esc(ad.name) + ' <span class="rt-pn">' + esc(ad.pn) + "</span>" : none) + "</td>" +
      "<td>" + (frame || none) + "</td>" +
      "<td>" + (st === "listed" && kit && kit.price ? (qualifyPrices ? "From " : "") + '<span class="rt-num">' + Fit.money(kit.price) + "</span>" : st === "confirm" ? "Call" : none) + "</td></tr>";
  }

  // maker chips: the first word of the airplane's handle, named the way pilots say it
  var MAKERS = { beechcraft: "Beechcraft", beech: "Beechcraft", cessna: "Cessna", cirrus: "Cirrus", rockwell: "Commander", aero: "Commander",
    piper: "Piper", daher: "Daher TBM", socata: "SOCATA", north: "North American", mooney: "Mooney", navion: "Navion", diamond: "Diamond" };

  function wire(section) {
    var body = section.querySelector("[data-fits-body]");
    var q = section.querySelector("[data-fits-q]");
    var count = section.querySelector("[data-fits-count]");
    var fold = section.querySelector("[data-fits-fold]");
    var chipsBox = section.querySelector("[data-fits-makers]");
    var state = "all", maker = "";
    var rows = body.querySelectorAll("tr");
    function makerOf(tr) { return MAKERS[tr.getAttribute("data-maker")] || ""; }

    // counts from the rows themselves: one row per airplane
    var n = { all: rows.length, listed: 0, confirm: 0, no_fit: 0 };
    Array.prototype.forEach.call(rows, function (tr) { var st = tr.getAttribute("data-status"); if (n[st] != null) n[st]++; });
    Array.prototype.forEach.call(section.querySelectorAll("[data-fits-n]"), function (el) { el.textContent = n[el.getAttribute("data-fits-n")]; });
    var total = section.querySelector("[data-fits-total]");
    if (total) total.textContent = " (" + rows.length + ")";

    function openFold() { if (fold && !fold.open) fold.open = true; }
    function apply() {
      var text = q ? q.value.trim().toLowerCase() : "";
      var shown = 0;
      Array.prototype.forEach.call(rows, function (tr) {
        var ok = (state === "all" || tr.getAttribute("data-status") === state) &&
          (!maker || makerOf(tr) === maker) &&
          (!text || (tr.getAttribute("data-search") || "").indexOf(text) !== -1);
        tr.hidden = !ok;
        if (ok) shown++;
      });
      if (count) count.textContent = "Showing " + shown + " of " + rows.length + " airplanes.";
    }
    if (q) q.addEventListener("input", function () {
      // typing searches every maker
      if (maker && chipsBox) { maker = ""; Array.prototype.forEach.call(chipsBox.querySelectorAll("[data-maker]"), function (x) { x.setAttribute("aria-pressed", x.getAttribute("data-maker") === "" ? "true" : "false"); }); }
      openFold(); apply();
    });
    Array.prototype.forEach.call(section.querySelectorAll("[data-fits-state]"), function (b) {
      b.addEventListener("click", function () {
        state = b.getAttribute("data-fits-state");
        Array.prototype.forEach.call(section.querySelectorAll("[data-fits-state]"), function (x) { x.setAttribute("aria-pressed", x === b ? "true" : "false"); });
        if (state !== "all") openFold();
        apply();
      });
    });
    if (chipsBox) {
      var tally = {};
      Array.prototype.forEach.call(rows, function (tr) { var m = makerOf(tr); if (m) tally[m] = (tally[m] || 0) + 1; });
      var names = Object.keys(tally).filter(function (m) { return tally[m] > 1; }).sort();
      chipsBox.innerHTML = ['<button type="button" class="rt-chip" aria-pressed="true" data-maker="">All makers</button>'].concat(names.map(function (m) {
        return '<button type="button" class="rt-chip" aria-pressed="false" data-maker="' + m + '">' + m + "</button>";
      })).join("");
      chipsBox.addEventListener("click", function (e) {
        var b = e.target.closest("[data-maker]");
        if (!b) return;
        maker = b.getAttribute("data-maker");
        Array.prototype.forEach.call(chipsBox.querySelectorAll("[data-maker]"), function (x) { x.setAttribute("aria-pressed", x === b ? "true" : "false"); });
        if (maker) openFold();
        apply();
      });
    }
    apply();
  }

  function start() {
    Array.prototype.forEach.call(tables, function (section) {
      var body = section.querySelector("[data-fits-body]");
      if (body.hasAttribute("data-fits-fill") && Fit) {
        Fit.ready(function (d) {
          var ids = (section.getAttribute("data-ids") || "").split(",").filter(Boolean);
          var list = d.aircraft.filter(function (a) { return (!ids.length || ids.indexOf(a.id) !== -1); });
          var maps = { fit: pages(section.getAttribute("data-fit-pages")), cohort: pages(section.getAttribute("data-cohort-pages")) };
          body.innerHTML = list.map(function (a) { return rowHTML(a, maps, section.hasAttribute("data-qualify-prices")); }).join("");
          wire(section);
        });
      } else {
        wire(section);
      }
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
